<section class="card">
  <div class="card-header">
    <h3 class="card-title">
      {{ 'operationModule.operations' | translate }}
    </h3>
  </div>
  <operation-table
    [tableData]="operations$ | async"
    (onClickRow)="onClickPendingOperation($event)"
    [isLoading]="isLoading$ | async"
    (searchTerm)="onSearchTerm($event)"
    [showPageFooter]="true"
    [showTotal]="true"
    [removeSearchTerm$]="removeSearchTerm$.asObservable()"
    [limitPage]="limit"
    [activePage]="page"
    [showIspending]="true"
    [total]="total"
    [pageCount]="pageCount"
    (onSelectedPage)="selectNewPage($event)"
    (onSelectLimit)="selectNewLimit($event)"
    (onSearchTerm)="onSearchTerm($event)"
    (onSorted)="onSorted($event)"
  ></operation-table>
</section>
